export const newLineSplit = (label: string) => {
    return label?.split('\r\n').map((x, i) => {
        return <div key={i}>{x}</div>
    });
}